const questions = [
  'что необходимо развивать;',
  'зачем это необходимо;',
  'какой уровень требуется;',
  'какой уровень сейчас;',
  'какие действия должен выполнить сотрудник;',
  'кто помогает в развитии;',
  'в какие сроки;',
  'как будет оцениваться результат.',
];

export default function WhatIsIPR() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Что такое индивидуальный план развития
        </h2>
        <p className="text-teal-700 font-semibold text-center text-base md:text-lg mb-10">
          ИПР — это не просто список курсов
        </p>

        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-start">
          <div>
            <p className="text-base md:text-lg text-gray-700 leading-relaxed mb-6">
              Индивидуальный план развития — это конкретный план действий сотрудника по развитию необходимых компетенций. Он превращает понимание того, чего сотруднику не хватает, в понятную последовательность шагов.
            </p>
            <p className="text-base text-gray-700 leading-relaxed mb-6">
              Хороший ИПР отвечает минимум на восемь вопросов:
            </p>
            <ul className="space-y-2 mb-6">
              {questions.map((q) => (
                <li key={q} className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-line text-teal-600 mt-1 flex-shrink-0"></i>
                  <span className="text-gray-700 text-sm md:text-base">{q}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="bg-gray-50 rounded-2xl border border-gray-200 p-6 md:p-8">
            <h3 className="text-lg font-bold text-gray-900 mb-4">Принцип формулировки цели</h3>
            <div className="space-y-5">
              <div className="bg-red-50 border border-red-100 rounded-xl p-4">
                <div className="flex items-center gap-2 mb-2">
                  <i className="ri-close-circle-line text-red-500"></i>
                  <span className="text-xs font-semibold text-red-600 uppercase tracking-wide">Неправильно</span>
                </div>
                <p className="text-sm text-gray-700 leading-relaxed">
                  «Пройти тренинг по коммуникации»
                </p>
              </div>
              <div className="flex justify-center">
                <i className="ri-arrow-down-line text-teal-600 text-xl"></i>
              </div>
              <div className="bg-teal-50 border border-teal-100 rounded-xl p-4">
                <div className="flex items-center gap-2 mb-2">
                  <i className="ri-checkbox-circle-line text-teal-600"></i>
                  <span className="text-xs font-semibold text-teal-700 uppercase tracking-wide">Правильно</span>
                </div>
                <p className="text-sm text-gray-700 leading-relaxed">
                  «Научиться проводить сложные разговоры по определённому алгоритму и продемонстрировать навык в реальной рабочей ситуации»
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}